// Copyright (c) 2022 WiseTime. All rights reserved.

import React from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components/macro"
import SvgIcon from "../../shared/SvgIcon"
import * as TimelineActions from "../actions"
import { IconButton } from "../../shared/styles"
import { t } from "@lingui/macro"
import { RemoveFromTimeGroupRequest } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

const StyledSvgIcon = styled(SvgIcon)`
  width: 14px;
  min-width: 14px;
  height: 14px;
  vertical-align: 0;
  color: ${({ theme }) => theme.colors.white};
`

export const Wrapper = styled.div`
  display: none;
  position: absolute;
  top: 1px;
  left: 67px;
  background-color: ${({ theme }) => theme.colors.perano};
  border: 1px solid ${({ theme }) => theme.colors.hawkesBlue};
  border-radius: 4px;
`

const Button = styled.button`
  ${IconButton};

  &:hover {
    background-color: ${({ theme }): string => theme.colors.indigo};
  }
`

type Props = {
  timeGroupId: string,
  timeRowId: string,
  className?: string,
}

const RemoveFromGroupButton = ({
  timeGroupId,
  timeRowId,
  className,
}: Props) => {
  const dispatch = useDispatch()
  return (
    <Wrapper className={className}>
      <Button
        title={t({ id: "label_send_back_to_timeline", message: "Send back to Timeline" })}
        onClick={(event: React.MouseEvent<HTMLElement>): void => {
          event.stopPropagation()
          const request = new RemoveFromTimeGroupRequest()
            .setTimeGroupId(timeGroupId)
            .setTimeRowIdsList([timeRowId])
          dispatch(TimelineActions.removeFromTimeGroup(request))
        }}
      >
        <StyledSvgIcon name="arrow-return"/>
      </Button>
    </Wrapper>
  )
}

export default RemoveFromGroupButton
